<template>
    <div class="navbar-fixed">
        <nav>
            <div class="nav-wrapper nav-bar white">
                <a href="" class="brand-logo nav-brand black-text"><img src="/static/2_line_64.png" alt="logo et nom du site sur une ligne"></a>
                <ul id="nav-mobile" class="right hide-on-med-and-down">
                    <li><ctabutton></ctabutton></li>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
import Ctabutton from './Ctabutton'

export default {
  name: 'navbar',
  components: {Ctabutton}
}
</script>

<style scoped>
.nav-brand {
    margin-left: 1%;
}
@media screen and (max-width: 600px){
    .nav-brand {
        margin-top: -8px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue